/**
 * Transformed downloads — agentic-integrations via `integrationsClient`
 * (`/api/v1/integration/transformer-exports/**`). integrations resolves the
 * transformer, records the run and triggers export-service; the webapp then
 * follows the returned `exportId` on the existing export-service status stream.
 */

import { integrationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { StartTransformerExportRequest, TransformerRun } from '../types/transformer.types';

import { unwrapEnvelope } from './transformer.service';

/** Start a transformed export (202). 422 `NO_TRANSFORMER` when nothing is assigned. */
export async function startTransformerExport(
  payload: StartTransformerExportRequest,
): Promise<TransformerRun> {
  const body = await integrationsClient
    .post(endpoints.transformerExports.list(), { json: payload })
    .json<unknown>();
  return unwrapEnvelope<TransformerRun>(body);
}
